export default __webpack_public_path__ + "static/media/admission.5bfd0c92.webp";